export const ARROW_ICON_SIZE = 7;
export const FILTER_ICON_SIZE = 20;
export const SORT_ICON_SIZE = 14;
